<div #mapContainer style="height: 500px; width: 100%;"></div>